var exports = {
  "X": "SectionHeader__BN5EiP",
  "J": "SectionHeader__body__5rsSAV",
};

module.exports = exports;
